/* eslint-disable */
// @ts-nocheck

import { StyleSheet, Text, View } from '@react-pdf/renderer'

import SignatureLine from '@/reports/components/report/SignatureLine'

const styles = StyleSheet.create({
  pageNumber: {
    position: 'absolute',
    fontSize: 9,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  signLines: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginTop: 40,
    flexWrap: 'wrap',
    display: 'flex',
  },
  signContainer: {
    marginTop: 60,
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
})

const Footer = ({ signLineTexts = [] }: { signLineTexts?: string[] }) => {
  return (
    <>
      <View style={styles.signLines}>
        {signLineTexts.map((text) => (
          <View style={styles.signContainer}>
            <SignatureLine underlineText={text} />
          </View>
        ))}
      </View>

      <Text
        fixed
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        style={styles.pageNumber}
      />
    </>
  )
}
export default Footer
